import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { LuLayoutDashboard } from 'react-icons/lu';
import './UserAsideNav.css';
import { RiLockPasswordLine } from 'react-icons/ri';
import GetLocalStorageUserId from '../../../sharedComponents/GetLocalStorageuserId';
import { toast } from 'react-toastify';
import ToggleButton from '../../../sharedComponents/navbar/sub_component/ToggleButton';
import logo from '../../../../assets/images/Logo-no-bg.png';
import { buildIdentityChangePasswordUrl, redirectToIdentityChangesPassword } from '../../../../utils/identityLogin.js';
import NotificationBell from '../../../sharedComponents/notifications/NotificationBell';
import SignalRConnectionPill from '../../../sharedComponents/notifications/SignalRConnectionPill';

const UserAsideNav = () => {
  // get local storage data.
  const localdata = localStorage.getItem('sundorbonBookingUserDetails');
  const Name = JSON.parse(localdata)?.Name || '';
  const Email = JSON.parse(localdata)?.Email || '';

  const [showAside, setShowAside] = useState(false);
  const [toggleBtnChecked, setToggleBtnChecked] = useState(false);
  const ToggleEventHandler = (e) => {
    e.stopPropagation();
    setShowAside(e.target.checked);
    setToggleBtnChecked(e.target.checked);
  };

  const handleChangePasswordClick = () => {
    redirectToIdentityChangesPassword(window.location.origin);
  };

  const move = useNavigate();
  const logoutHandle = () => {
    toast.success('Logout Successfull', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
    localStorage.removeItem('sundorbonBookingUserDetails');
    localStorage.removeItem('token');
    move('/');
  };

  // route change handle.

  const NavBarhandle = () => {
    console.log('fired.');
    setToggleBtnChecked(false);
    setShowAside(false);
  };

  const Routes = (
    <>
      <NavLink
        onClick={NavBarhandle}
        end
        className='flex lg:w-full items-center hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'/user-dashboard'}
      >
        <LuLayoutDashboard />
        Dashboard
      </NavLink>

      <NavLink
        onClick={handleChangePasswordClick}
        className='flex lg:w-full items-center hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        //to={'change-password'}
      >
        {/* <RiLockPasswordLine /> */}
        Change Password
      </NavLink>
    </>
  );

  return (
    <div className='xl:w-[17%] lg:w-[25%] lg:flex z-30 flex-col justify-start items-start lg:gap-12 lg:pb-11 overflow-hidden lg:pt-11 w-full lg:h-[93vh] lg:rounded-[25px] lg:sticky top-0 lg:top-[3%] lg:left-2 xl:left-5 bg-black text-white lg:bg-[#b4b4b4]'>
      {/* top image and profile text info. */}
      <div className='relative hidden lg:w-full lg:flex justify-center items-center flex-row lg:flex-col'>
        {/* <img
          className="w-full px-3 object-contain  lg:inline-block hidden xl:h-[142px] lg:h-[100px] "
          src={logo}
          alt="logo"
        /> */}
        <Link to='/' onClick={() => setShowAside(false)}>
          <img
            className='w-full max-w-[220px] px-3 object-contain  lg:inline-block hidden xl:h-[142px] lg:h-[100px]'
            src={logo}
            alt='logo'
          />
        </Link>
        <div className='lg:mt-[54px] hidden text-center lg:block w-full px-3'>
          <div className='flex items-center justify-between gap-2'>
            <div className='min-w-0 flex-1'>
              <h1 className='text-xl font-semibold truncate'>{Name}</h1>
              <h1 className='text-base font-semibold mt-1 truncate'>{Email}</h1>
            </div>
            <div className='flex flex-col items-end gap-1.5 shrink-0'>
              <NotificationBell variant='dark' />
              <SignalRConnectionPill compact />
            </div>
          </div>
        </div>
      </div>
      {/* aside nav bar */}
      <ul className='w-full  hidden scrollbar lg:h-[81%] lg:overflow-y-auto lg:pr-5 lg:pl-3 lg:flex flex-col gap-y-1 xl:text-xl text-lg text-white'>
        {Routes}
        {/* <li>
          <Link
            className="flex items-center text-white gap-x-1"
            to={"/agency-bookings"}
          >
            Add Booking
          </Link>
        </li> */}
      </ul>

      {/* for mobile view. */}
      <div className=' lg:hidden block z-50 text-white  w-full  '>
        <div className='relative z-50 flex items-center justify-between pr-2 bg-[#424242]'>
          <ToggleButton
            value={toggleBtnChecked}
            showAside={showAside}
            eventHandle={ToggleEventHandler}
          />

          {/* <img
            className="rounded-full absolute left-[44%] top-[10px] w-[65px] h-[65px]"
            src={logo}
            alt="logo"
          /> */}

          {/* {GetLocalStorageUserId() ? (
            <button onClick={logoutHandle} className="">
              Logout
            </button>
          ) : (
            <Link to={"/login"}>Login</Link>
          )} */}
          <div className='flex items-center gap-2 pr-2'>
            <NavLink
              to='/bookings'
              className='text-white px-3 py-2 text-sm rounded-md'
            >
              Booking
            </NavLink>

            {GetLocalStorageUserId() ? (
              <>
                <SignalRConnectionPill compact />
                <NotificationBell variant='dark' />
              </>
            ) : null}

            {GetLocalStorageUserId() ? (
              <button
                onClick={logoutHandle}
                className='text-white px-3 py-2 text-sm rounded-md'
              >
                Logout
              </button>
            ) : (
              <Link
                to='/login'
                className='text-white px-3 py-2 text-sm rounded-md'
              >
                Login
              </Link>
            )}
          </div>

          {/* <button className="">
            <Link to={"/login"}>Login</Link>
          </button> */}
        </div>

        <div
          className={`w-full bg-[#424242]   duration-300  absolute  z-40 ${
            showAside ? 'translate-y-0' : '-translate-y-[2000px]'
          }`}
        >
          <ul className='flex   flex-col pb-4 gap-y-3 justify-center text-[20px] font-normal items-start pl-[40px]'>
            {Routes}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserAsideNav;
